import React from "react"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
class StoresSystem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addStores:
            {
                createdBy: "",
                createdDate: "",
                location: "",
                modifiedBy: "",
                modifiedDate: "",
                name: "",
                material: "",
                storeId: null,
                parts: "",
                pchmchm: "",
                purchaseOrderId: null,
                quantity: "",
                remarks: "",
                shipId: null,
                unit: "",
                isUpdated: false,
                isDeleted: false
            },
            Stores: []
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const { match, option } = this.props;
        const { params } = match;
        const { shipid, poid } = params;
        if (option == "Add") {
            this.state.addStores.shipId = parseInt(shipid);
            this.state.addStores.purchaseOrderId = parseInt(poid);
        }
    }

    hideSidePanel = () => {
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    static getDerivedStateFromProps(props, state) {
        return {
            Stores: props.store,
            addStores: props.updateDetails,
        };
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.addStores[nodeName] = e.target.value;
        this.state.addStores.isUpdated = true;
        this.setState({});
    }

    addStoresDetails() {
        this.state.addStores.isDeleted = false;
        this.state.Stores.unshift({...this.state.addStores});
        this.props.dispatch({ type: "GetStoreSuccess", data: this.state.Stores });
        // this.setState({addStores:
        //     {
        //         createdBy: "",
        //         createdDate: "",
        //         location: "",
        //         modifiedBy: "",
        //         modifiedDate: "",
        //         name: "",
        //         material: "",
        //         storeId: null,
        //         parts: "",
        //         pchmchm: "",
        //         purchaseOrderId: null,
        //         quantity: "",
        //         remarks: "",
        //         shipId: null,
        //         unit: "",
        //         isUpdated: false,
        //         isDeleted: false
        //     }});
        // this.hideSidePanel();
    }

    UpdateStoresDetails() {
        const { addStores } = this.state;
        var index = this.state.Stores.findIndex(x => x.storeId === addStores.storeId);
        if (index === -1) {
            // handle error
        }
        else {
            this.setState({
                Stores: [
                    ...this.state.Stores.slice(0, index),
                    Object.assign({}, this.state.Stores[index], addStores),
                    ...this.state.Stores.slice(index + 1)
                ]
            }, () => {
                this.props.dispatch({ type: "GetStoreSuccess", data: this.state.Stores });
                this.hideSidePanel();
            });
        }
    }

    cancel() {
        this.hideSidePanel();
    }


    render() {
        const { option } = this.props;

        return (
            <div className="row" style={{ paddingBottom: '338px' }}>
                <div className="full-height pt-3">
                    <div className="grey-bg  course-list-page">
                        <div className="panel-box  search-filter-box mb-4">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                        </button>
                            <div className="resource-list-auth-date">
                                <div className="card mt-2 MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            {option == "Add" ? "Add " : "Update "} Stores
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Name </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.name} name="name" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Location </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.location} name="location" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Materials </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.material} name="material" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Parts </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.parts} name="parts" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-12 col-sm-12">
                                                <label className="form-label">Remarks </label><br></br>
                                                <textarea className="form-control" value={this.state.addStores.remarks} name="remarks" onChange={e => this.handleInputChange(e)} ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                            Approximate Quantity
                                    </h5>
                                    </div>
                                    <div className="search-filter-box">
                                        <div className="row mb-2">
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Quantity </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.quantity} name="quantity" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">Unit </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.unit} name="unit" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                            <div className="col-md-6 col-sm-6">
                                                <label className="form-label">PCHM / CHM </label><br></br>
                                                <input type="text" className="form-control" value={this.state.addStores.pchmchm} name="pchmchm" onChange={e => this.handleInputChange(e)} ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 search-filter-box mt-2">
                                        <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                            {this.props.option === "Add" ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.addStoresDetails()}
                                                >
                                                    {" "}Add{" "}
                                                </button>
                                                : null}
                                            {this.props.option === "Edit" ?
                                                <button
                                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                    type="submit" onClick={() => this.UpdateStoresDetails()}
                                                >
                                                    {" "}Update{" "}
                                                </button>
                                                : null}
                                            <button
                                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                type="button" onClick={() => this.cancel()}
                                            >
                                                {" "}Cancel{" "}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        ShowSidePan: state.SidePanReducer.sidePan || false,
        store: state.MMPLDashboardReducer.Store || [],

    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StoresSystem));